import { ApexOptions } from 'apexcharts';

export function generateOptions(
  data: { price_type: string; price: string; created_at: Date }[],
) {
  function formatDate(dateString: string) {
    // Проверяем корректность входных данных
    if (!dateString?.includes('T')) {
      throw new Error('Некорректный формат даты');
    }
    // Извлекаем только дату без времени
    const datePart = dateString.split('T')[0];
    // Разбиваем на части и меняем порядок
    const [year, month, day] = datePart.split('-');
    // Возвращаем отформатированную строку
    return `${day}.${month}.${year}`;
  }
  const categories = data?.map((item) => formatDate(String(item.created_at)));
  const minIndent = 0.9;
  const maxIndent = 1.1;

  const yaxisMin = (ymin: number, val: number): number =>
    ymin * val > 0 ? ymin * val : 0;

  var options: ApexOptions | any = {
    chart: {
      type: 'line',
      zoom: {
        enabled: true,
        allowMouseWheelZoom: false,
      },
      events: {
        zoomed: (chartEl: any, { xaxis, yaxis }: any) => {
          const allPricesArray = chartEl?.w.globals.stackedSeriesTotals;
          const periodPricesArray = allPricesArray.slice(xaxis.min - 1, xaxis.max);
          const yMin = Math.min(...periodPricesArray);
          const yMax = Math.max(...periodPricesArray);

          const updateYAxis = () => ({
            yaxis: {
              min: yaxis
                ? yaxisMin(yMin, minIndent)
                : yaxisMin(Math.min(...allPricesArray), minIndent),
              max: yaxis ? yMax * maxIndent : Math.max(...allPricesArray) * maxIndent,
              tickAmount: 5,
              labels: {
                formatter: (val: number) =>
                  `${Math.round(val).toLocaleString('RU-ru')} ₽/т`,
                style: {
                  fontFamily: 'Roboto, Arial, sans-serif',
                  fontSize: 12,
                  fontWeight: 400,
                  colors: '#373d3f',
                },
              },
            },
          });
          chartEl.updateOptions({
            ...updateYAxis(),
            ...(!yaxis && {
              xaxis: {
                categories,
                tickAmount: 10,
                labels: {
                  showDuplicates: false,
                  rotate: 0,
                  hideOverlappingLabels: true,
                },
                min: 1,
                max: allPricesArray.length,
                tickPlacement: 'on',
              },
            }),
          });
        },
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      width: 1,
      curve: 'smooth',
    },

    series: [
      {
        name: 'цена',
        data: data?.map((item) => item.price),
        color: '#66B28A',
      },
    ],
    markers: {
      size: 1.5,
      strokeWidth: 0,
    },
    xaxis: {
      categories: categories,
      tickAmount: 10,
      labels: {
        showDuplicates: false,
        rotate: 0,
        hideOverlappingLabels: true,
      },
      min: 1,
      tickPlacement: 'on',
    },
    yaxis: {
      max: function (val: number) {
        return val * maxIndent; // не большой отступ сверху
      },
      min: function (val: number) {
        return yaxisMin(val, minIndent); // не большой отступ снизу
      },
      tickAmount: 5,
      labels: {
        formatter: (val: number) => `${Math.round(val).toLocaleString('RU-ru')} ₽/т`,
        style: {
          fontFamily: 'Roboto, Arial, sans-serif',
          fontSize: 12,
          fontWeight: 400,
          colors: '#373d3f',
        },
      },
    },
    grid: {
      padding: {
        right: 30,
      },
    },
    tooltip: {
      enabled: true,
      marker: {
        show: true,
      },
    },
  };

  return options;
}
